import { Badge, Button, ConfigProvider, List, Typography } from 'antd';
import React, { useState } from 'react';
//import styled from 'styled-components';
import ReactPlayer from 'react-player';
import EmptyResult from '../../../../common/components/EmptyResult';
import useHttpHelper from '../../../../common/hooks/useHttpHelper';
import { appLinks } from '../../../../config/constants';


//const { Text } = Typography;

// const TitleComponent = styled.span`
// font-size: 16px;
// font-weight: bold;
// `

// const sectionTypeMapper = {
//     'steps': 'Steps'
// }

const StepItem = (props) => {

    const {
        title,
        voiceLink,
        allowApprove,
        allowRegenerate,
        allowRemove,
        onApprove,
        onRegenerate,
        onRemove,
        dataId,
        text, 
        color
    } = props

    // if needs review then approve or reject actions
    // if rejected then no action
    // if approved then allow regenerate

    // available actions
    // approve, regenerate
    // status text and color: 
    // needs review: orange
    // approved: #52c41a // a shade of green
    // regenerate: #1890ff // a shade of blue

    const [actionState, setActionState] = useState('')

    const onApproveClick = async () => {
        try {
            setActionState('approving')
            await  onApprove(dataId)
            setActionState('done')
        } catch (error) {
            console.error('Error approving generated voice:', error);
            setActionState('done')
        }
    }

    const onRegenerateClick = async () => {
        try {
            setActionState('regenerating')
            await  onRegenerate(dataId)
            setActionState('done')
        } catch (error) {
            console.error('Error regenerating generated voice:', error);
            setActionState('done')
        }
    }

    const onRemoveClick = async () => {
        try {
            setActionState('removing')
            await  onRemove(dataId)
            setActionState('done')
        } catch (error) {
            console.error('Error removing generated voice:', error);
            setActionState('done')
        }
    }



    const isApproving = actionState === 'approving'

    const isRegenerating = actionState === 'regenerating'

    const isRemoving = actionState === 'removing'

    const isBusy = isApproving || isRegenerating || isRemoving


    //console.log('sectoin step resources', type, customTitle)

    return (
        <List.Item >
            <div className='step-item'>
                <Typography.Text>{title}</Typography.Text>
                {
                    !!voiceLink ? (
                        <div className='step-item-actions-container'>
                            <ReactPlayer
                                url={voiceLink}
                                controls
                                width="380px"
                                height="50px"
                            />

                            <div className='step-item-actions'>
                                <Badge showZero color={color ?? '#faad14'} className='step-action-badge' />
                                <Typography.Text>{text}</Typography.Text>
                                <Button
                                    onClick={onApproveClick}
                                    loading={isApproving}
                                    type="primary"
                                    size="small"
                                    disabled={!allowApprove || isBusy}
                                    className='step-action-button'>Approve</Button>
                                <Button
                                    onClick={onRegenerateClick}
                                    loading={isRegenerating}
                                    type="secondary"
                                    size="small"
                                    disabled={!allowRegenerate || isBusy}
                                    className='step-action-button'>Regenerate</Button>
                                {allowRemove ? <Button
                                    onClick={onRemoveClick}
                                    loading={isRemoving}
                                    type="secondary"
                                    size="small"
                                    disabled={!allowRemove || isBusy}
                                    className='step-action-button'>Remove</Button> : null}
                            </div>

                        </div>
                    ) : null
                }
            </div>
        </List.Item>
    )

}

const EmptySteps = () => <EmptyResult description='No steps' />

const StepSection = (props) => {

    const { reloadDetails } = props

    const steps = props.sections?.[0]?.items ?? []

    const { httpPostAsync } = useHttpHelper();

    const updateVoiceDataStatus = async (id, status) => {
        try {

            const postData = { status}

            const response = await httpPostAsync(
                appLinks.updateVoiceDataStatus.replace('{id}', id),
                postData
            );

            return response
        
        } catch (error) {
            console.error('Error updating generated voice status :', error);
        }
    }

    const onApprove = async (id) => {
        try {

           const response = await  updateVoiceDataStatus(id, 'Reviewed')

            reloadDetails()

            // refetch challenge details
        
        } catch (error) {
            console.error('Error approving step:', error);
        }
    }

    const onRegenerate = async (id) => {
        try {
            const response = await  updateVoiceDataStatus(id, 'Regenerate')

            reloadDetails()
        } catch (error) {
            console.error('Error regenerating step:', error);
        }
    }

    const onRemove = async (id) => {
        try {
            const response = await  updateVoiceDataStatus(id, 'Remove')

            reloadDetails()
        } catch (error) {
            console.error('Error removing regenerating step:', error);
        }
    }

    return (
        <ConfigProvider renderEmpty={EmptySteps}>
            <List
                className='step-list'
                dataSource={steps}
                renderItem={item => (<StepItem
                    {...item}
                    onRegenerate={onRegenerate}
                    onApprove={onApprove}
                    onRemove={onRemove}
                />)}
            />
        </ConfigProvider>
    )

}

// const sectionFactory = {
//     'steps': StepSection
// }

// const SectionElement = (props) => {

//     const { type } = props;

//     const SectionComponent = useMemo(() => {
//         return get(sectionFactory, type, EmptyComponent)
//     }, [type]);

//     return (<SectionComponent {...props} />)
// }

export default StepSection

// export default (props) => {

//     const steps = props.sections?.[0]?.items ?? []

//     return (
//         <div>
//             <StepSection items={steps} />
//         </div>
//     )


// }


